var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _linearGradient10, _path10, _linearGradient11, _path11, _linearGradient12, _path12, _linearGradient13, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M320,88.809v-6.914c0-4.852-2.164-9.387-5.938-12.438c-3.781-3.055-8.672-4.227-13.422-3.207 l-95.992,20.57C197.32,88.391,192,94.969,192,102.469V104h-4c-15.438,0-28,12.562-28,28s12.562,28,28,28h4v1.062 c0,7.91,5.906,14.719,13.734,15.836l2.266,0.324V200c0,13.234,10.766,24,24,24c6.484,0,12.523-2.535,16.859-6.988 C253.469,212.531,256,206.488,256,200v-15.92l45.734,6.534c0.758,0.109,1.516,0.164,2.266,0.164c3.828,0,7.555-1.375,10.484-3.918 c3.508-3.039,5.516-7.441,5.516-12.082v-7.586c18.234-3.717,32-19.876,32-39.191S338.234,92.526,320,88.809z M192,144h-4 c-6.617,0-12-5.383-12-12s5.383-12,12-12h4V144z M240,200c0,2.137-0.82,4.105-2.445,5.695C236.102,207.184,234.133,208,232,208 c-4.414,0-8-3.59-8-8v-20.492l16,2.286V200z M304,174.777l-96-13.715v-58.594l96-20.574V174.777z M320,150.526v-45.052 c9.292,3.313,16,12.11,16,22.526S329.292,147.213,320,150.526z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    x2: 256,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M392,344c13.234,0,24-10.766,24-24v-16h24c22.055,0,40-17.945,40-40V40c0-22.055-17.945-40-40-40H72 C49.945,0,32,17.945,32,40v224c0,22.055,17.945,40,40,40h144.355l7.272,160H160c-13.234,0-24,10.766-24,24s10.766,24,24,24h192 c13.234,0,24-10.766,24-24s-10.766-24-24-24h-63.629l5.432-120H392z M392,232h-59.719l-13.625-20.438 c-2.969-4.453-10.344-4.453-13.312,0L291.719,232H272c-13.234,0-24,10.766-24,24H88c-4.414,0-8-3.59-8-8V56c0-4.41,3.586-8,8-8h336 c4.414,0,8,3.59,8,8v192c0,4.41-3.586,8-8,8h-8C416,242.766,405.234,232,392,232z M272,344h5.786l-5.432,120h-32.708l-7.272-160H248 v16C248,333.234,258.766,344,272,344z M72,288c-13.234,0-24-10.766-24-24V40c0-13.234,10.766-24,24-24h368c13.234,0,24,10.766,24,24 v224c0,13.234-10.766,24-24,24h-24v-16h8c13.234,0,24-10.766,24-24V56c0-13.234-10.766-24-24-24H88c-13.234,0-24,10.766-24,24v192 c0,13.234,10.766,24,24,24h160v16H72z M352,480c4.414,0,8,3.59,8,8s-3.586,8-8,8H160c-4.414,0-8-3.59-8-8s3.586-8,8-8H352z M272,328 c-4.414,0-8-3.59-8-8v-64c0-4.41,3.586-8,8-8h24c2.672,0,5.172-1.336,6.656-3.562L312,230.422l9.344,14.016 c1.484,2.227,3.984,3.562,6.656,3.562h64c4.414,0,8,3.59,8,8v64c0,4.41-3.586,8-8,8H272z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 388,
    x2: 388,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M400,120h-24c-4.422,0-8,3.582-8,8s3.578,8,8,8h24c4.422,0,8-3.582,8-8S404.422,120,400,120z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 380,
    x2: 380,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M368,104.004c0.836,0,1.688-0.133,2.531-0.414l24-8c4.188-1.398,6.453-5.93,5.055-10.121 c-1.398-4.188-5.883-6.477-10.117-5.059l-24,8c-4.188,1.398-6.453,5.93-5.055,10.121C361.531,101.883,364.648,104.004,368,104.004z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 380,
    x2: 380,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M394.531,160.41l-24-8c-4.219-1.406-8.727,0.867-10.117,5.059c-1.398,4.191,0.867,8.723,5.055,10.121 l24,8c0.844,0.281,1.695,0.414,2.531,0.414c3.352,0,6.469-2.121,7.586-5.473C400.984,166.34,398.719,161.809,394.531,160.41z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 124,
    x2: 124,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M104,112h40c4.422,0,8-3.582,8-8V72c0-4.418-3.578-8-8-8h-40c-4.422,0-8,3.582-8,8v32 C96,108.418,99.578,112,104,112z M112,80h24v16h-24V80z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 112,
    x2: 112,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M104,208h16c4.422,0,8-3.582,8-8s-3.578-8-8-8h-16c-4.422,0-8,3.582-8,8S99.578,208,104,208z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 144,
    x2: 144,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M184,224h-80c-4.422,0-8,3.582-8,8s3.578,8,8,8h80c4.422,0,8-3.582,8-8S188.422,224,184,224z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 168,
    x2: 168,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M184,192h-32c-4.422,0-8,3.582-8,8s3.578,8,8,8h32c4.422,0,8-3.582,8-8S188.422,192,184,192z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 356,
    x2: 356,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M328,280h56c4.422,0,8-3.582,8-8s-3.578-8-8-8h-56c-4.422,0-8,3.582-8,8S323.578,280,328,280z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 288,
    x2: 288,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M280,280h16c4.422,0,8-3.582,8-8s-3.578-8-8-8h-16c-4.422,0-8,3.582-8,8S275.578,280,280,280z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 372,
    x2: 372,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M384,296h-24c-4.422,0-8,3.582-8,8s3.578,8,8,8h24c4.422,0,8-3.582,8-8S388.422,296,384,296z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 304,
    x2: 304,
    y1: 8.34,
    y2: 493.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6695f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28d35"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M328,296h-48c-4.422,0-8,3.582-8,8s3.578,8,8,8h48c4.422,0,8-3.582,8-8S332.422,296,328,296z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.cfdfff4a235296f7938200a1115580c2.svg";
export { ForwardRef as ReactComponent };